<div class="device-list-container">
    <div class="table-row table-header">
        <div class="column model">
            {{ 'device-list.unit.header.model' | translate }}
        </div>
        <div class="column item-code">
            {{ 'device-list.unit.header.item-code' | translate }}
        </div>
        <div class="column description">
            {{ 'device-list.unit.header.description' | translate }}
        </div>
        <div class="column options"></div>
    </div>
    <div class="table-row" [class.expanded]="isDescriptionExpanded">
        <app-device-model-dropdown
            class="column model"
            [modelOptions]="models"
            [unitModel]="selectedModel"
            (onModelSelected)="handleModelSelected($event)">
        </app-device-model-dropdown>

        <div class="column item-code" [class.emptyCell]="!selectedModel?.code">
            {{ selectedModel?.code ? selectedModel?.code : '-' }}
        </div>

        <app-description-cell
            class="description"
            [description]="selectedModel?.description"
            (expandedChange)="isDescriptionExpanded = $event"></app-description-cell>

        <div class="column options" #optionsCol>
            <mat-icon svgIcon="more-options" class="icon" (click)="updatePosition(); isOptionsOpen = !isOptionsOpen" />
            <div class="options-container" *ngIf="isOptionsOpen" [style.top]="optionsTop">
                <div class="option-row" (click)="deleteUnit()">
                    <mat-icon svgIcon="delete" class="delete-icon icon-margin" />
                    {{ 'dlg.clear' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
